export default {
  addReportSuccessMessage: 'tests.addReportSuccessMessage',
  addReportErrorMessage: 'tests.addReportErrorMessage',
  missingManualResultsMessage: 'tests.missingManualResultsMessage',
  buttonText: 'tests.addReport',
  textareaLabel: 'tests.report',
  inputLabel: 'tests.doctorName'
};
